



















import Vue from "vue";
import { Categories, SelectedCategoryIds } from "@tt-app/models";

import TtFilterResetButton from "@tt-app/components/ui/TtFilterResetButton.vue";

interface Props {
  categories: Categories;
  categorySelectionHandler: (event: MouseEvent) => void;
  selectedCategoryIds: SelectedCategoryIds;
}

export default Vue.extend<{}, {}, {}, Props>({
  name: "CategoryFilter",
  components: {
    TtFilterResetButton
  },
  props: {
    categories: { type: Object, required: true },
    categorySelectionHandler: { type: Function, required: true },
    selectedCategoryIds: { type: Object, required: true }
  },
  computed: {
    selectedCategoryCount() {
      return Object.values(this.selectedCategoryIds).filter(categoryStatus => {
        return categoryStatus;
      }).length;
    }
  }
});
